import React, { ReactElement } from 'react'

import Card from '../../../../../1stlog-ui/src/components/Card'
import EmailLabelRequested from '../EmailLabelRequested'
import PrintLabelRequested from '../PrintLabelRequested'
import CustomerReference from './CustomerReference'

const Misc = (): ReactElement => {
  return (
    <Card title={i18n.t('order_extras', 'Sonstiges')}>
      <CustomerReference />
      <PrintLabelRequested />
      <EmailLabelRequested />
    </Card>
  )
}

export default Misc
